import {Alert} from '@mui/material';
import {Link} from 'react-router-dom';

import {APP_ROUTES} from '../../../const';
import usePayment from '../../../hooks/providers/usePayment';
import UpgradeSubscriptionEmailsList from '../../contact/UpgradeSubscriptionEmailsList/UpgradeSubcriptionEmailsList';

const InsufficientSubscriptionForCreatingConnectionsAlert = () => {
  const {isPartner, isGuest, numberOfProjectsOwnedByAllUsers, productSubscribed, maxNumberOfProjects, hasUnpaidInvoice} = usePayment();
  const userHasInsufficientSubscriptionForCreatingConnections = numberOfProjectsOwnedByAllUsers > maxNumberOfProjects;

  const shouldDisplayAlert = userHasInsufficientSubscriptionForCreatingConnections && productSubscribed && !isGuest;

  if (!shouldDisplayAlert || hasUnpaidInvoice) return null;

  return (
    <Alert severity="error">
      {isPartner ? (
        <UpgradeSubscriptionEmailsList />
      ) : (
        <>
          <Link to={APP_ROUTES.profile}>Mettez à niveau votre abonnement</Link>&nbsp; pour activer les services, ou supprimez les connexions dont vous n'avez plus besoin pour continuer à utiliser les
          autres connexions.
        </>
      )}
    </Alert>
  );
};

export default InsufficientSubscriptionForCreatingConnectionsAlert;
